import { AxiosPromise, AxiosResponse } from 'axios';
import loginMock from './LoginMock';
import { RequestMethod } from '../ApiRequest';
import ZipCodeCheckMock from './ZipcodeCheckMock';
import RegisterMock from './RegisterMock';
import UpdateProfileMock from './UpdateProfileMock';
import ChangePasswordMock from './ChangePasswordMock';
import GetUserMock from './GetUserMock';

const ApiMock = (method: RequestMethod, route: string, data?: any): Promise<AxiosResponse> => {
  if (route === 'bearer' && method === 'POST') {
    return loginMock(data);
  }

  if (route.startsWith('search/zipcode?zipcode=') && method === 'GET') {
    return ZipCodeCheckMock();
  }

  if (route === 'client') {
    if (method === 'GET') {
      return GetUserMock();
    }

    if (method === 'POST') {
      return RegisterMock(data);
    }

    if (method === 'PUT') {
      return UpdateProfileMock(data);
    }
  }

  if (route === 'client/change-password' && method === 'POST') {
    return ChangePasswordMock(data);
  }

  return new Promise((resolve, reject) => {
    setTimeout(() => {
      reject({
        response: {
          data: {
            message: 'Page not found',
          },
          status: 404,
        },
      });
    }, 150);
  });
};

function pageNotFound(): Promise<AxiosResponse> {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({
        data: {
          message: 'Cadastrado com sucesso!',
        },
        status: 200,
        statusText: 'OK',
        headers: {},
        config: {},
      });
    }, 150);
  });
}

export default ApiMock;
